export default __webpack_public_path__ + "static/media/rest_for_pets.2c25272f.png";